import React, { useState }   from 'react';
import axios from 'axios';
import './Titlebar.css';


axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

const Titlebar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleFileChange = (event) => {
    setSelectedFile(Array.from(event.target.files));
  };

  const handleUpload = async () => {
    const formData = new FormData();
    console.log(selectedFile);
    selectedFile.forEach(file =>{
      formData.append('file', file);
    })

    try {
      const response = await axios.post('https://coasters.davidschnieders.de/backend/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log(response.data);
      const id = response.data['id']
    } catch (error) {
      console.error('Error uploading file:', error);
    }
    closeModal();
    window.location.reload();
  };

  return (
    <div className="title-bar">
        <div className="menu-icon">
          {/* Your menu items go here */}
          <div className="uploadbutton" onClick={openModal}>Upload</div>
        </div>
      {modalOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>&times;</span>
            <h2>Upload Photo</h2>
              <input type="file" multiple onChange={handleFileChange} /> <br/>
              <button onClick={handleUpload}>Upload</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Titlebar;
